import { bool, func, object, string } from 'prop-types';
import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import FileDownloader from '../../generic/FileDownloader';
import { parseSKUs, wrongSKUsError } from '../../generic/flash-messages/utils';
import { highlightedSkusShape } from '../../prop-types';
import createCSV from '../../utils/create-csv';

function WrongSKUsActionModal({
  isOpen,
  onConfirm,
  onDismiss,
  error,
  highlightedSkus,
  productCode,
}) {
  const errorMessage = wrongSKUsError(error);
  const updatedSKUs = parseSKUs(errorMessage);
  const errorMessageWithoutSKUs = errorMessage.replace(/\[.*?\]/, '').trim();

  const currentHighlightedSKUs =
    highlightedSkus && highlightedSkus[productCode];

  const wrongSKUs =
    currentHighlightedSKUs &&
    currentHighlightedSKUs
      ?.filter(sku => !updatedSKUs?.includes(sku))
      .map(wrongSku => ({ sku: wrongSku }));

  const handleConfirmAction = () => {
    if (updatedSKUs) {
      onConfirm(updatedSKUs);
    }
  };

  const isDownloadDisabled = !wrongSKUs || wrongSKUs?.length === 0;

  return (
    <Modal isOpen={isOpen} toggle={onDismiss}>
      <ModalHeader toggle={onDismiss}>Wrong SKUs</ModalHeader>
      <ModalBody>
        <p>{errorMessageWithoutSKUs}</p>
      </ModalBody>
      <ModalFooter className="justify-content-start">
        <Button
          onClick={handleConfirmAction}
          color="primary"
          disabled={!updatedSKUs}
        >
          Exclude Non-Valid SKUs
        </Button>
        <FileDownloader
          disabled={isDownloadDisabled}
          onGetFile={async () => {
            return createCSV(
              'invalid skus',
              [{ accessor: 'sku', label: 'Non-Valid SKUs' }],
              wrongSKUs,
            );
          }}
        >
          Download Non-Valid SKUs
        </FileDownloader>
        <Button onClick={onDismiss}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
}

WrongSKUsActionModal.propTypes = {
  isOpen: bool.isRequired,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
  error: object, // eslint-disable-line react/forbid-prop-types
  highlightedSkus: highlightedSkusShape,
  productCode: string.isRequired,
};

WrongSKUsActionModal.defaultProps = {
  error: {},
  highlightedSkus: {},
};

export default WrongSKUsActionModal;
